import PropTypes from 'prop-types';
import { Form, DatePicker } from 'antd';
import EbzProductsFilter from 'components/EbzProductsFilter/EbzProductsFilter';
import EbzTreeSelect from 'components/EbzTreeSelect';

function DashBoardFilterPage({
  formName,
  productList,
  merchants,
  dashBoardForm,
  RANGE_PRESETS_DAYS,
  disabledDate,
  fetchMerchantList,
  merchantLoading,
  setMerchantPagination,
  merchantTransactionListRef,
  selectedMerchantTotalCounts,
  submerchants,
  fetchSubMerchantList,
  submerchantLoading,
  setSubmerchantPagination,
  submerchantTransactionListRef,
  selectedSubmerchantTotalCounts
}) {
  const { RangePicker } = DatePicker;

  return (
    <Form layout="vertical" form={dashBoardForm} name={formName} className="dashboard-form">
      <Form.Item
        className="dashboard-products-date-filter"
        name="dashboardRangePicker"
        label="Date"
        rules={[
          {
            required: true,
            message: 'Please select valid date'
          },
          {
            validator(_, value) {
              if (
                value &&
                value[0] !== null &&
                value[1] !== null &&
                value[1].diff(value[0], 'days') >= 31
              ) {
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject('Please Select Max Up to One Month');
              }
              return Promise.resolve();
            }
          }
        ]}
      >
        <RangePicker
          activeBg="#1677ff"
          activeShadow="1 1 1 2px rgba(20, 145, 255, 0.1)"
          style={{ borderRadius: '3px', width: '100%' }}
          presets={RANGE_PRESETS_DAYS}
          disabledDate={disabledDate}
        />
      </Form.Item>

      <Form.Item
        label="Choose Merchants"
        className="dashboard-products-merchant-filter"
        name="dashboardMerchantId"
      >
        <EbzTreeSelect
          merchants={merchants}
          fetchMerchantList={fetchMerchantList}
          merchantLoading={merchantLoading}
          setMerchantPagination={setMerchantPagination}
          formName={formName}
          inputSearchPlaceholder="Please Search Merchants"
          inputPlaceholder="Choose Merchants"
          merchantTransactionListRef={merchantTransactionListRef}
          selectedMerchantTotalCounts={selectedMerchantTotalCounts}
        />
      </Form.Item>

      <Form.Item
        className="dashboard-products-product-list-filter"
        label="Choose Products"
        name="dashboardProducts"
      >
        <EbzProductsFilter data={productList} />
      </Form.Item>

      {selectedSubmerchantTotalCounts > 0 && (
        <Form.Item
          label="Choose Submerchants"
          className="dashboard-products-submerchant-filter"
          name="dashboardSubMerchantId"
        >
          <EbzTreeSelect
            merchants={submerchants}
            fetchMerchantList={fetchSubMerchantList}
            merchantLoading={submerchantLoading}
            formName={formName}
            inputSearchPlaceholder="Please Search Submerchants"
            inputPlaceholder="Choose Submerchants"
            setMerchantPagination={setSubmerchantPagination}
            merchantTransactionListRef={submerchantTransactionListRef}
            selectedMerchantTotalCounts={selectedSubmerchantTotalCounts}
          />
        </Form.Item>
      )}
    </Form>
  );
}

DashBoardFilterPage.propTypes = {
  formName: PropTypes.string.isRequired,
  productList: PropTypes.instanceOf(Array).isRequired,
  merchants: PropTypes.instanceOf(Array).isRequired,
  dashBoardForm: PropTypes.instanceOf(Object).isRequired,
  RANGE_PRESETS_DAYS: PropTypes.instanceOf(Array).isRequired,
  disabledDate: PropTypes.func.isRequired,
  fetchMerchantList: PropTypes.func.isRequired,
  merchantLoading: PropTypes.bool.isRequired,
  setMerchantPagination: PropTypes.func.isRequired,
  merchantTransactionListRef: PropTypes.instanceOf(Object).isRequired,
  selectedMerchantTotalCounts: PropTypes.number.isRequired,
  submerchants: PropTypes.instanceOf(Array).isRequired,
  fetchSubMerchantList: PropTypes.func.isRequired,
  submerchantLoading: PropTypes.bool.isRequired,
  setSubmerchantPagination: PropTypes.func.isRequired,
  submerchantTransactionListRef: PropTypes.instanceOf(Object).isRequired,
  selectedSubmerchantTotalCounts: PropTypes.number.isRequired
};

export default DashBoardFilterPage;
